import React, { useRef } from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { FormattedNumber, FormattedDate } from 'react-intl';
import './PrintUpdatePaymentPlanConfirmTable.scss';

interface Props {
    PageData?: any;
    Model?: any;
}
export const PrintUpdatePaymentPlanConfirmTable = React.forwardRef(
    ({ PageData, Model }: Props, ref: any) => {
        const LOGO_ICONS_PATH = `${process.env.PUBLIC_URL}/images/logo/`;
        const hoistLogo = `${LOGO_ICONS_PATH}/hoist_logo_color.svg`;

        return (
            <div ref={ref}>
                <div id="container">
                    <header>
                        <img className="logo" src={hoistLogo} width="272" />
                    </header>

                    <div>
                        <h2>{PageData?.PaymentDetailsHeader}</h2>
                        
                        <table className="details-table-poland">
                            <thead>
                                <tr>
                                    <th>{PageData?.PlanTablePaymentColumnLabel}</th>
                                    <th>{PageData?.PlanTableDateColumnLabel}</th>
                                    <th>{PageData?.PlanTableAmountColumnLabel}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Model.InstallmentPlan.map((item: { Number: any; Date: any; Amount: any; }) =>

                                    <tr>
                                        <td className="center">{item.Number}</td>
                                        <td className="center">
                                            <FormattedDate
                                                value={item?.Date}
                                            /></td>
                                        <td className="center"> <FormattedNumber
                                            style="currency"
                                            currency={Model?.Currency}
                                            value={item?.Amount/100}
                                        />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td className="center footer">{PageData?.PlanTableFinalPaymentLabel}</td>
                                    <td></td>
                                    <td className="right footer">
                                        <FormattedNumber
                                            style="currency"
                                            currency={Model?.Currency}
                                            value={Model?.TotalAmount/100}
                                        />
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div >
            </div>
        );
    },
);